class url {
    constructor() {
        this.urlMaster = ''
        
    }

    url = () => {
        return this.urlMaster
    }
}
export default url;
